import FieldsPanelContainer from "./FieldsPanelContainer";

export default FieldsPanelContainer;
